export enum WizardStepName {
  Start,
  PrimaryUse,
  NeedToRun,
  UseCase,
  Brands,
  Results
}